import React, { useMemo } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMenuPaths, isPathAllowedByMenu } from '../utils/menuPaths';

/**
 * Protege la ruta por sesión y por menú:
 * - Si no hay usuario → redirige a login.
 * - Si hay usuario pero la ruta actual no está en su menú → redirige a inicio (sin permisos).
 * Así, aunque se conozca la URL, no se puede acceder si la opción no está pintada en el menú.
 */
const MenuProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname;

  const allowedPaths = useMemo(() => {
    try {
      const raw = localStorage.getItem('menu');
      const menu = raw ? JSON.parse(raw) : null;
      return getMenuPaths(menu);
    } catch {
      return new Set();
    }
  }, []);

  const isAllowed = useMemo(
    () => isPathAllowedByMenu(pathname, allowedPaths, true),
    [pathname, allowedPaths]
  );

  if (!user) {
    return <Navigate to="/inicio-sesion" replace state={{ from: location }} />;
  }

  if (!isAllowed) {
    return <Navigate to="/" replace state={{ from: location, reason: 'no_permission' }} />;
  }

  return children;
};

export default MenuProtectedRoute;
